import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    width: '100%'
  },
  content: {
    marginTop: 32,
    '& .MuiGrid-item': {
      [theme.breakpoints.up('sm')]: {
        flexBasis: '50%',
        maxWidth: '50%'
      }
    }
  },
  cardWrapper: {
    maxWidth: '260px'
  }
}))
